import styled from 'styled-components';

export const StyledCellCustomButtons = styled.div`
  display: flex;

  button {
    margin: 0 1rem;

    &:last-of-type {
      margin-right: 0;
    }
  }
`;

export const StyledActionLoadingWrap = styled.div`
  display: flex;
  align-items: center;

  .action-loading {
    margin-right: 1rem;
  }
`;
